import { useParams } from "react-router-dom";
import "./HPUserActivityLogsPage.scss";
import ActivityLogsPage from "../../../components/ActivityLogsPage/ActivityLogsPage";
import { GetCalendarDataForLogsInHP, GetUserActivityLogsHP } from "../../../utils/apiCalls/logs";

const HPUserActivityLogsPage = () => {
  // Keying on the route param forces a full remount when navigating between
  // different users' logs, so filters/pagination/date state never leak across ids.
  const { userId } = useParams();
  return (
    <ActivityLogsPage
      key={userId}
      idParam="userId"
      idTransform={Number}
      fetchLogs={GetUserActivityLogsHP}
      fetchCalendar={GetCalendarDataForLogsInHP}
      backRoute="/patient-logs"
      defaultFromTab="users"
    />
  );
};

export default HPUserActivityLogsPage;
